export default "__VITE_ASSET__OevcJvFw__"